import { ambientAudio, playbackAudio } from '../../sound/audioSession'

const MEDIA = 'video, audio'
let installedOn: Document | null = null

/**
 * One clip at a time (spec §8): starting any video or audio in the app pauses whichever was playing. On iPhones a clip
 * someone starts plays out loud even with the silent switch on; once nothing plays, notification sounds keep to it again.
 */
export function playOneAtATime(doc: Document = document): void {
  if (installedOn === doc) return
  installedOn = doc
  // Media events don't bubble, but every one passes the document on its way down.
  doc.addEventListener(
    'play',
    (event) => {
      const started = event.target
      if (!(started instanceof HTMLMediaElement)) return
      for (const element of doc.querySelectorAll<HTMLMediaElement>(MEDIA)) {
        if (element !== started && !element.paused) element.pause()
      }
      playbackAudio()
    },
    true,
  )
  const stopped = () => ambientAudio(doc)
  doc.addEventListener('pause', stopped, true)
  doc.addEventListener('ended', stopped, true)
}
